import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';

import * as actions from './actions';
import { EditorContainer, QuillContainer, AlignBox, AlignBoxLeft, AlignBoxRight } from './styles';
import { Button } from '../../components';
import { Spinner } from '../../../components/Spinner/spinner';
import { useActions } from 'hooks/useActions';

const Editor = {
  modules: {
    toolbar: [
      [{ header: '1' }, { header: '2' }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['code-block', 'link', 'clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  },
  formats: ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link', 'align', 'code-block'],
};

export default function CommentEditor({ onCancel, onPostSuccess, testId, contestId, respondsTo }) {
  const { postComment } = useActions(actions);
  const {
    createCommentStatus: { [respondsTo ? respondsTo : 'root']: commentStatus },
  } = useSelector((state) => state.comments);

  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    if (commentStatus === 'success') {
      setNewComment('');
      if (onPostSuccess) {
        onPostSuccess();
      }
    }
  }, [commentStatus, onPostSuccess]);

  return (
    <EditorContainer>
      {commentStatus === 'posting' && <Spinner />}
      {commentStatus !== 'posting' && (
        <>
          <QuillContainer>
            <ReactQuill
              value={newComment}
              onChange={(updatedValue) => setNewComment(updatedValue)}
              modules={Editor.modules}
              formats={Editor.formats}
              theme="snow"
              preserveWhitespace={true}
            />
          </QuillContainer>
          <AlignBox>
            <AlignBoxLeft />
            <AlignBoxRight>
              {onCancel && (
                <Button small primaryBlue primaryGreenBorder removeMargin type="submit" onClick={() => onCancel()}>
                  Cancel
                </Button>
              )}
              <Button
                small
                primaryBlue
                primaryGreenBorder
                removeMargin
                type="submit"
                disabled={!newComment || commentStatus === 'posting'}
                onClick={() => postComment(newComment, testId, contestId, respondsTo)}
              >
                Post Comment
              </Button>
            </AlignBoxRight>
          </AlignBox>
        </>
      )}
    </EditorContainer>
  );
}
